<template>
  <div :style="column.align ? `text-align:${column.align}` : ''">
    <v-menu v-model="menuOpen" :close-on-content-click="false" >
      <template v-slot:activator="{ attrs, on }">
        <p class="full-height pt-1" v-bind="attrs" v-on="{ ...on, click: () => menuOpen = true }">
          {{ absence[column.columnName] }}
        </p>
      </template>
      <v-list>
        <v-text-field
            autofocus
            class="ma-0 px-1 py-0"
            hide-details="true"
            @focus="initialValue = absence[column.columnName]"
            @blur="saveText({ absence, property })"
            @keyup.enter="saveText({ absence, property })"
            @keyup.esc="cancelEdit()"
            v-model="absence[column.columnName]"
        ></v-text-field>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: 'TextCellEdit',
  props: {
    column: Object,
    absence: Object,
    isAssignedToDifferentView: Boolean,
    property: String,
  },
  data() {
    return {
      menuOpen: false,
      initialValue: false,
    };
  },
  methods: {
    /**
     * Save the text
     * @param {object} args
     */
    saveText(args) {
      this.$emit('inlineChange', args);
      this.menuOpen = false;
    },
    cancelEdit() {
      this.absence[this.column.columnName] = this.initialValue;
      this.menuOpen = false;
    },
  },
};
</script>